import React from 'react';

export default function LogisticsDelivery() {
  return (
    <section id="logistics" className="py-20 lg:py-28 relative overflow-hidden">
      <div className="container mx-auto px-4 lg:px-8 relative z-10">

        {/* Header */}
        <div className="max-w-6xl mx-auto mb-16">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-clay mb-4">Logistics & Delivery</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-gray-900 mb-6 max-w-3xl">
            From Uganda to your doorstep
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl leading-relaxed">
            Your coffee is cleared through customs and ready to ship from our Karachi warehouse. The hard part is already done.
          </p>
        </div>

        {/* Timeline — labels stack below the circle so the connector rule never crosses them */}
        <ol className="max-w-6xl mx-auto mb-16 grid grid-cols-1 md:grid-cols-4 gap-x-6 gap-y-10 relative">
          {/* Rule from the centre of circle 1 to circle 4; circles sit at each column's left edge (gap-x-6 puts column 4 at 75% + 18px) */}
          <div aria-hidden="true" className="hidden md:block absolute top-7 left-7 right-[calc(25%-46px)] h-px bg-gray-300" />

          {/* Step 1 — done */}
          <li className="relative">
            <span className="relative z-10 inline-flex items-center justify-center w-14 h-14 rounded-full lining-nums bg-gray-900 text-white font-heading text-xl">1</span>
            <p className="mt-4 text-xs uppercase tracking-[0.2em] text-gray-500">Done</p>
            <h3 className="mt-2 text-lg font-bold text-gray-900">Farm in Uganda</h3>
            <p className="mt-1 text-sm text-gray-700">Grown and processed in Nabutaka.</p>
          </li>

          {/* Step 2 — done */}
          <li className="relative">
            <span className="relative z-10 inline-flex items-center justify-center w-14 h-14 rounded-full lining-nums bg-gray-900 text-white font-heading text-xl">2</span>
            <p className="mt-4 text-xs uppercase tracking-[0.2em] text-gray-500">Done</p>
            <h3 className="mt-2 text-lg font-bold text-gray-900">Shipped to Pakistan</h3>
            <p className="mt-1 text-sm text-gray-700">Container by sea to Karachi.</p>
          </li>

          {/* Step 3 — you are here */}
          <li className="relative">
            <span className="relative z-10 inline-flex items-center justify-center w-14 h-14 rounded-full lining-nums bg-clay text-white font-heading text-xl ring-4 ring-clay/20">3</span>
            <p className="mt-4 text-xs uppercase tracking-[0.2em] text-clay font-semibold">You are here</p>
            <h3 className="mt-2 text-lg font-bold text-clay">Customs cleared</h3>
            <p className="mt-1 text-sm text-gray-700">Duty paid, sitting in our warehouse.</p>
          </li>

          {/* Step 4 — pending */}
          <li className="relative">
            <span className="relative z-10 inline-flex items-center justify-center w-14 h-14 rounded-full lining-nums bg-white border-2 border-gray-300 text-gray-400 font-heading text-xl">4</span>
            <p className="mt-4 text-xs uppercase tracking-[0.2em] text-gray-500">Next</p>
            <h3 className="mt-2 text-lg font-bold text-gray-900">Delivery in 2-3 days</h3>
            <p className="mt-1 text-sm text-gray-700">Direct to your warehouse or cafe.</p>
          </li>
        </ol>

        {/* Three concrete benefits as a definition list */}
        <dl className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-y-6 md:gap-x-10 md:gap-y-0 border-t border-gray-300 pt-10">
          <div>
            <dt className="font-heading text-2xl text-clay mb-2">Zero duties on top</dt>
            <dd className="text-gray-700">We've paid customs, so no duties are added to the price you see.</dd>
          </div>
          <div>
            <dt className="font-heading text-2xl text-clay mb-2">No freight wait</dt>
            <dd className="text-gray-700">Stock is already in Karachi, so you skip the months at sea.</dd>
          </div>
          <div>
            <dt className="font-heading text-2xl text-clay mb-2">No import paperwork</dt>
            <dd className="text-gray-700">Domestic delivery. No licenses, permits, or customs forms on your side.</dd>
          </div>
        </dl>

      </div>
    </section>
  );
}
